export const GET_ONE_DRIVE = '@HEADCOUNT/GET_ONE_DRIVE'
export const GET_ONE_DRIVE_FOLDER_MOVE = '@HEADCOUNT/GET_ONE_DRIVE_FOLDER_MOVE'
export const DELETE_FILE = '@HEADCOUNT/DELETE_FILE'
export const CHANGE_NAME = '@HEADCOUNT/CHANGE_NAME'
export const CREATE_FOLDER = '@HEADCOUNT/CREATE_FOLDER'
export const MOVE_ITEM = '@HEADCOUNT/MOVE_ITEM'
export const UPLOAD_FILE = '@HEADCOUNT/UPLOAD_FILE'
export const GET_DRIVES_HOT_LOAD = '@HEADCOUNT/GET_DRIVES_HOT_LOAD'
export const GET_PORTFOLIO = '@HEADCOUNT/GET_PORTFOLIO'
export const GET_BREAD = '@HEADCOUNT/GET_BREAD'
export const GET_ONE_DRIVE_AND_BREAD = '@HEADCOUNT/GET_ONE_DRIVE_AND_BREAD'
export const GET_FILES_T0_DOWNLOAD_FOLDER = '@HEADCOUNT/GET_FILES_T0_DOWNLOAD_FOLDER'
export const REMOVE_FILES_T0_DOWNLOAD_FOLDER = '@HEADCOUNT/REMOVE_FILES_T0_DOWNLOAD_FOLDER'
export const UPLOAD_FOLDER = '@HEADCOUNT/UPLOAD_FOLDER'
